import { memo, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useParams } from 'react-router-dom';

import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';

import SimpleSearchInput from 'components/SearchInputNavbar';
import ProductHistory from './ProductHistory';

const Products = () => {
  const { setComponent } = useTopPanel();
  const { id } = useParams();
  const [refetch, setRefetch] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [itemData, setItemData] = useState('');

  useEffect(() => {
    setComponent(
      <div className='component-title'>Chiqarilgan mahsulotlar</div>
    );
  }, []);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 gap-2 flex items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath={`admin/warehouses/outcomes/${id}`}
          emitTableColumns={{ open, setOpen }}
          tableName='admin/warehouses/outcomes/'
          headCells={[
            { code: 'id', label: '#' },
            { code: 'master', label: 'Master' },
            { code: 'warehouse', label: 'Ombor' },
            { code: 'date', label: 'Sana' },
            { code: 'sum', label: 'Summa' },
            { code: 'valute', label: 'Valyuta' },
            { code: 'comment', label: 'Izoh' },
          ]}
          columns={[
            { code: 'id' },
            { code: 'master', type: 'nested', childStr: 'name' },
            { code: 'warehouse', type: 'nested', childStr: 'name' },
            { code: 'date', type: 'date' },
            { code: 'sum', type: 'priceSum' },
            { code: 'valute', type: 'price' },
            { code: 'comment' },
          ]}
          actionsList={[
            {
              icon: 'bi bi-eye',
              btnColor: 'warning',
              setOpen: setOpenModal,
              setData: setItemData,
            },
          ]}
        />
      </div>
      {openModal && (
        <ProductHistory
          open={openModal}
          setOpen={setOpenModal}
          itemData={itemData}
          setItemData={setItemData}
          setRefetch={setRefetch}
        />
      )}
    </div>
  );
};

export default memo(Products);
